module.exports = __webpack_public_path__ + "img/icon2(2).184dbd91.png";